import { action } from '@ember/object';
import SettingsAgentsBaseController from '../base';
import AgentModel from 'scaleflow/models/agent';

export default class SettingsAgentsListCreateController extends SettingsAgentsBaseController {
  declare model: AgentModel;

  @action
  cancel() {
    // Delete the record instead of just rolling back
    void this.model.destroyRecord();
    this.goToListPage();
  }
}
